import React from "react";
import { addSurveyAnswers } from "@utils/redux/slices/surveyAnswers";
import { isMantle, isWinback } from "@utils/userSegment";
import { isCareFirstRedirectEligible } from "@utils/userSegment/features";
import { trackEvent } from "@utils/api/tracker";
import i18n from "@i18n";
import { FullScreen } from "../core/BodyLayout";
import NavBar from "@components/nav-bar/NavBar";
import {
  disclaimerSetBelowFold,
  useShowDisclaimer,
} from "../results-vary-disclaimer/ResultsVaryDisclaimer";

import { setNavTimeout } from "src/utils/timing";
import { useAppDispatch } from "src/hooks/redux";
import { usePageSet } from "src/hooks/pageSet";
import { useTrackScroll } from "src/hooks/scroll";
import { IntroCTA } from "./IntroCTA";
import { Splash } from "./Splash";
import { Headline } from "./Headline";
import { IntroBackground } from "./IntroBackground";
import styled from "@emotion/styled";
import { compassColors } from "src/utils/styling";
import { CareFirstCTA } from "../carefirst/CareFirstCTA";
import { useSmallScreenCheck } from "src/hooks/viewport";
import { isHolidayPromotion } from "src/utils/holidayPromo";
import { HolidayPromoBanner } from "../banner/HolidayPromoBanner";

export const IntroContainer = styled(FullScreen)`
  background: ${compassColors.offWhite};
`;

const CareFirstContainer = styled.div`
  width: 53%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
`;

const CareFirstInnerContainer = styled.div`
  width: 90%;
`;

export function Intro() {
  const shouldUseDualLogoCTA = !isMantle() && !isWinback();
  const dispatch = useAppDispatch();
  const { gotoNextPage } = usePageSet();
  const isSmallScreen = useSmallScreenCheck();

  useTrackScroll("ScrolledFromTop");

  const shouldShowDisclaimer = useShowDisclaimer();
  const disclaimerFixedPosition = disclaimerSetBelowFold();

  function addHealthGoal(goal) {
    trackEvent("ClickHealthGoalButton", { goal });
    dispatch(
      addSurveyAnswers({
        healthGoals: goal,
      })
    );

    // A short timeout is added before redirecting so that the users will see their selection highlighted.
    setNavTimeout(() => {
      gotoNextPage();
    }, 500);
  }

  function startSurvey() {
    trackEvent("ClickedContinueButton");
    gotoNextPage();
  }

  return (
    <IntroContainer
      disclaimerBelowFold={shouldShowDisclaimer && disclaimerFixedPosition}
    >
      {isHolidayPromotion() && <HolidayPromoBanner />}
      <NavBar />
      <IntroBackground shouldUseSmallMobileBG={shouldUseDualLogoCTA} />
      <Splash>
        <Headline />
        {shouldUseDualLogoCTA && <p>{i18n.t("introv3:line2")}</p>}
        <IntroCTA
          shouldUseDualLogoCTA={shouldUseDualLogoCTA}
          onAddHealthGoal={addHealthGoal}
          onStartSurvey={startSurvey}
        />
        {isSmallScreen && isCareFirstRedirectEligible() && (
          <CareFirstCTA pageId="landing" />
        )}
      </Splash>
      {!isSmallScreen && isCareFirstRedirectEligible() && (
        <CareFirstContainer>
          <CareFirstInnerContainer>
            <CareFirstCTA pageId="landing" />
          </CareFirstInnerContainer>
        </CareFirstContainer>
      )}
    </IntroContainer>
  );
}

export default Intro;
